const STORAGE_KEY = "pwa_cart_v1";

const defaultCart = () => ({
  items: [],
  updatedAt: new Date().toISOString(),
});

const safeRead = () => {
  if (typeof window === "undefined") return defaultCart();

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : defaultCart();
  } catch (error) {
    console.warn("No se pudo leer el carrito.", error);
    return defaultCart();
  }
};

const safeWrite = (cart) => {
  if (typeof window === "undefined") return;

  try {
    const payload = {
      ...cart,
      updatedAt: new Date().toISOString(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (error) {
    console.warn("No se pudo guardar el carrito.", error);
  }
};

export const initCart = () => {
  if (typeof window === "undefined") return;

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(defaultCart()));
    }
  } catch (error) {
    console.warn("No se pudo inicializar el carrito.", error);
  }
};

export const getCart = () => safeRead();

export const setCart = (cart) => safeWrite(cart);

const findItemIndex = (items, id, presentation) =>
  items.findIndex(
    (item) => item.id === id && item.presentation === presentation
  );

export const addItem = (payload) => {
  const cart = safeRead();
  const index = findItemIndex(cart.items, payload.id, payload.presentation);

  if (index >= 0) {
    cart.items[index].quantity += payload.quantity || 1;
  } else {
    cart.items.push({
      ...payload,
      quantity: payload.quantity || 1,
    });
  }

  safeWrite(cart);
  return cart;
};

export const removeItem = (id, presentation) => {
  const cart = safeRead();
  cart.items = cart.items.filter(
    (item) => !(item.id === id && item.presentation === presentation)
  );
  safeWrite(cart);
  return cart;
};

export const setQuantity = (id, presentation, quantity) => {
  const cart = safeRead();
  const index = findItemIndex(cart.items, id, presentation);
  if (index === -1) return cart;

  if (quantity <= 0) {
    cart.items.splice(index, 1);
  } else {
    cart.items[index].quantity = quantity;
  }

  safeWrite(cart);
  return cart;
};

export const getItemCount = (cart) =>
  cart.items.reduce((total, item) => total + item.quantity, 0);

export const getTotal = (cart) =>
  cart.items.reduce((total, item) => total + item.price * item.quantity, 0);

export const clearCart = () => {
  const empty = defaultCart();
  safeWrite(empty);
  return empty;
};
